const CART_KEY = 'bf_cart_items';

async function saveCartToLocal() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.items.length > 0) {
      localStorage.setItem(CART_KEY, JSON.stringify(cart.items));
    } else {
      localStorage.removeItem(CART_KEY);
    }
  } catch (e) {
    console.warn('cart-persist: erro ao salvar', e);
  }
}

async function mergeCartOnLoad() {
  const saved = localStorage.getItem(CART_KEY);
  if (!saved) return;

  let items;
  try { items = JSON.parse(saved); } catch { return; }

  const res = await fetch('/cart.js');
  const cart = await res.json();
  const currentIds = cart.items.map(i => i.variant_id);

  const toAdd = items
    .filter(i => !currentIds.includes(i.variant_id))
    .map(i => ({ id: i.variant_id, quantity: i.quantity }));

  if (toAdd.length === 0) {
    localStorage.removeItem(CART_KEY);
    return;
  }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: toAdd }),
  });

  localStorage.removeItem(CART_KEY);
}

// Intercepta fetch nativo pra capturar add, change e update
const _fetch = window.fetch;
window.fetch = async function(...args) {
  const res = await _fetch(...args);
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
    saveCartToLocal();
  }
  return res;
};

document.addEventListener('DOMContentLoaded', mergeCartOnLoad);

async function calcularFrete(cep, variantId) {
  const cepLimpo = cep.replace(/\D/g, '');
  if (cepLimpo.length !== 8) {
    return { erro: 'CEP inválido' };
  }

  try {
    const viaCepRes = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
    const viaCepData = await viaCepRes.json();

    if (viaCepData.erro) {
      return { erro: 'CEP não encontrado' };
    }

    let itemAdicionado = false;

    if (variantId) {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const jaEstaNoCarrinho = cart.items.some(i => i.variant_id === Number(variantId));

      if (!jaEstaNoCarrinho) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        itemAdicionado = true;
      }
    }

    const params = new URLSearchParams({
      'shipping_address[zip]': cepLimpo,
      'shipping_address[country]': 'BR',
      'shipping_address[province]': viaCepData.uf,
      'shipping_address[city]': viaCepData.localidade
    });

    const res = await fetch(`/cart/shipping_rates.json?${params.toString()}`);
    const data = await res.json();

    if (itemAdicionado) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 0 })
      });
    }

    if (!data.shipping_rates || data.shipping_rates.length === 0) {
      return { erro: 'Não entregamos nessa região ainda' };
    }

    return {
      opcoes: data.shipping_rates.map(rate => ({
        nome: rate.name,
        preco: parseFloat(rate.price)
      }))
    };
  } catch (e) {
    return { erro: 'Erro ao calcular frete' };
  }
}

function initFreteCalc() {
  const btn = document.getElementById('calcular-frete-btn');
  const input = document.getElementById('cep-input');
  const resultado = document.getElementById('frete-resultado');

  if (!btn || !input || !resultado) return;

  btn.addEventListener('click', async () => {
    resultado.textContent = 'Calculando...';
    const variantId = document.querySelector('.bf-frete-produto')?.dataset.variantId;
    const res = await calcularFrete(input.value, variantId);

    if (res.erro) {
      resultado.textContent = res.erro;
      return;
    }

    resultado.innerHTML = `
      <p style="font-size: 13px; color: #666; margin: 8px 0 4px;">Escolha sua forma de entrega:</p>
      ${res.opcoes.map((o, i) => `
        <label class="frete-opcao" style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; padding: 8px 0; border-bottom: 1px solid rgba(var(--color-foreground), 0.05);">
          <span style="display: flex; align-items: center; gap: 8px;">
            <input type="radio" name="frete-opcao" value="${o.nome}" ${i === 0 ? 'checked' : ''}>
            ${o.nome}
          </span>
          <span>R$ ${o.preco.toFixed(2).replace('.', ',')}</span>
        </label>
      `).join('')}
    `;
  });
}

document.addEventListener('DOMContentLoaded', initFreteCalc);

// fallback pra quando o DOM já carregou (ex: Liquid personalizado renderiza depois)
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(initFreteCalc, 100);
}